import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import { connect } from 'react-redux';
import { replace } from 'connected-react-router';
import { Button, Flex, IconButton } from "onefaceui-react-components"

import { getResourceTo } from 'react/utils/utils';
import { actionCreators } from 'react/api/actions/monitor';

import MonetDateRange from 'react/monet/fields/daterange.jsx';
import MonetOrganization from 'react/monet/fields/organization.jsx';
import MonetTag from 'react/monet/fields/tag.jsx';

import CompactIcon from 'static/images/compact.svg';
import Comfortable from 'static/images/comfortable.svg';

import { createURL, getSearchParams } from './utils';

class Filter extends React.Component {
  static propTypes = {
    filter: PropTypes.object.isRequired,
    toggleViewMode: PropTypes.func.isRequired,
    cardViewMode: PropTypes.string.isRequired
  }

  state = {
    openedDates: false,
    openedOrg: false,
    openedTag: false,
    showAll: false,
    ARRIVED_ORIGIN: false,
    DEPARTED_ORIGIN: false,
    STARTED: false,
    NOT_STARTED: false,
    criteria: {
      queryParameter: '',
      status: [],
      startDate: '',
      endDate: '',
      organizationId: null,
      tagId: null
    },
    urlParams: '',
    isTyping: false
  }

  updateURL(url) {
    window.globalStore.dispatch(replace(url));
  }

  componentDidUpdate() {
    const { urlParams, isTyping } = this.state;
    const { active: { key } } = this.props.tabs.toJS();

    if (key === 'RouteMonitor') {
      const { criteria } = this.state;
      const { startDate, endDate, organizationId, queryParameter } = getSearchParams();
      const url = createURL({ startDate, endDate, organizationId, queryParameter });
      const existsCriteriaState = !!(criteria.startDate && criteria.endDate && criteria.organizationId && criteria.queryParameter);
      const existsCriteriaParams = !!(startDate && endDate && organizationId && queryParameter);
      const urlWithSearchParams = new URL(window.location.href.replace('#/', '')).searchParams;
      const shouldClearUrl = !existsCriteriaParams && urlWithSearchParams.size && !this.state.openedDates && !this.state.openedOrg && !this.state.criteria.queryParameter;

      if (urlParams !== url && !isTyping) {
        const criteriaExists = existsCriteriaState && !existsCriteriaParams;
        let params;

        if (criteriaExists) {
          params = {
            startDate: criteria.startDate,
            endDate: criteria.endDate,
            organizationId: criteria.organizationId,
            queryParameter: criteria.queryParameter,
          };
        } else {
          params = {
            startDate,
            endDate,
            organizationId,
            queryParameter
          }
        }
        const newUrlParams = createURL(params);

        const criteiraUpdated = {
          ...criteria,
          ...params
        };

        this.setState({
          ...this.state,
          urlParams: newUrlParams,
          criteria: criteiraUpdated,
          isTyping: false,
          openedDates: !!params.startDate,
          openedOrg: !!params.organizationId,
        }, this.requestRoutes);

        criteriaExists ? this.updateURL(newUrlParams) : this.updateURL('RouteMonitor');
      }

      if (shouldClearUrl) {
        this.updateURL('RouteMonitor');
      }

      if (existsCriteriaParams && this.refs.dateRange) {
        this.refs.dateRange.state.startDate = this.state.criteria.startDate;
        this.refs.dateRange.state.endDate = this.state.criteria.endDate;
      }
    }

    this.refs.dateRange?.updateState?.(this.state.openedDates);
    this.refs.organizationField?.updateState?.(this.state.openedOrg);
    this.refs.tagField?.updateState?.(this.state.openedTag);
    return true;
  }

  getRoutes = debounce((key, value) => {
    this.setState((prev) => {
      const newUrlParams = createURL({ ...prev.criteria, [key]: value });
      this.updateURL(newUrlParams);
      return {
        ...prev,
        criteria: {
          ...prev.criteria,
          [key]: value,
        },
        urlParams: newUrlParams
      }
    }, this.requestRoutes);

  }, 500)

  getRoutesByDates = (startDate, endDate) => {
    const { criteria } = this.state;
    const updatedCriteria = {
      ...criteria,
      startDate: startDate || '',
      endDate: endDate || ''
    };

    this.setState(
      {
        criteria: updatedCriteria
      },
      () => {
        this.requestRoutes();
      }
    );
  }

  handleDoneTyping = debounce(({ target: { value } }) => {

    this.setState((prev) => {
      const newUrlParams = createURL({ ...prev.criteria, queryParameter: value });
      this.updateURL(newUrlParams);

      return {
        ...prev,
        criteria: {
          ...prev.criteria,
          queryParameter: value,
        },
        urlParams: newUrlParams,
        isTyping: false
      }
    }, this.requestRoutes);

  }, 800);

  handleChange = ({ target: { value } }) => {

    this.setState((prev) => {
      const newUrlParams = createURL({ ...prev.criteria, queryParameter: value });
      this.updateURL(newUrlParams);
      return {
        ...prev,
        criteria: {
          ...prev.criteria,
          queryParameter: value,
        },
        urlParams: newUrlParams,
        isTyping: true
      }
    });
  }

  requestRoutes = () => {
    const { filter } = this.props;
    const { criteria } = this.state;

    window.globalStore.dispatch(actionCreators.request({
      ...filter,
      ...criteria,
      firstResult: 0
    }));
  }

  createNewState = (key) => {
    const { criteria } = this.state;
    let { showAll } = this.state;
    const value = !this.state[key];
    if (value) {
      criteria.status.push(key);
    } else {
      criteria.status = criteria.status.filter((status) => status !== key);
      showAll = false;
    }

    this.setState((prev) => ({
      ...prev,
      [key]: value,
      criteria,
      showAll
    }), this.requestRoutes);
  }

  toggle = (event) => {
    const { target: { dataset: { key } } } = event;
    switch (key) {
      case 'NOT_STARTED':
      case 'STARTED':
      case 'DEPARTED_ORIGIN':
      case 'ARRIVED_ORIGIN': {
        this.createNewState(key);
        break;
      }
      case 'openedDates': {
        const { criteria } = this.state;
        const visible = !this.state[key];
        const { startDate, endDate } = this.refs?.dateRange?.state || {};
        const currentCriteria = {
          ...criteria,
          startDate: (visible) ? startDate : '',
          endDate: (visible) ? endDate : '',
          organizationId: (visible) ? criteria.organizationId : '',
        };
        const newUrlParams = createURL({ ...currentCriteria });
        const newState = {
          ...this.state,
          criteria: {
            ...criteria,
            ...currentCriteria,
          },
          [key]: visible,
          urlParams: newUrlParams
        };
        this.updateURL(newUrlParams);
        this.setState(newState, this.requestRoutes);
        break;
      }
      case 'openedOrg': {
        const visible = !this.state[key];
        const { criteria } = this.state;
        const newUrlParams = createURL({ organizationId: '', ...criteria });
        this.setState({
          ...this.state,
          [key]: visible,
          criteria: {
            ...criteria,
            organizationId: ''
          },
          urlParams: newUrlParams
        }, this.requestRoutes);
        this.updateURL(newUrlParams);
        break;
      }
      case 'openedTag': {
        const visible = !this.state[key];
        const { criteria } = this.state;
        this.setState({
          ...this.state,
          [key]: visible,
          criteria: {
            ...criteria,
            tagId: null
          }
        }, this.requestRoutes);
        break;
      }
      default:
        break;
    }
  }

  clearFilters = () => {
    this.setState((prev) => ({
      ...prev,
      criteria: {
        ...prev.criteria,
        queryParameter: '',
        startDate: '',
        endDate: '',
        organizationId: null,
        tagId: null
      },
      urlParams: '',
      isTyping: false
    }))
    this.updateURL('');
  }

  render() {
    const { openedOrg, openedDates, openedTag } = this.state;
    const { cardViewMode, toggleViewMode } = this.props;
    const shouldRenderClearButton = openedOrg || openedDates || openedTag;

    return (
      <Flex
        dataTestId="route-monitor-list-filter"
        className="filterHeaderContainer"
        flexDirection="column"
      >
        <div className="filterHeaderTextField">
          <input
            data-testid="route-monitor-input-search"
            className="routeKey"
            id="routeKey"
            placeholder={getResourceTo('Monet.RouteMonitor.label.searchRoutes')}
            onKeyUp={this.handleDoneTyping}
            onChange={this.handleChange}
            value={this.state.criteria.queryParameter}
          />
          <label className="filterHeaderSearchIcon" htmlFor="routeKey" title="organization" />
        </div>
        <div className="filterHeaderGroup">
          <div className="routesFiltersGroup">
            <div className="filterHeaderLabel">{getResourceTo('Monet.RouteMonitor.label.showOnly')}</div>
            <IconButton
              dataTestId="not-started-button"
              className="filterHeaderFindNoStarted"
              data-active={this.state.NOT_STARTED}
              data-key="NOT_STARTED"
              message={getResourceTo('RouteMonitor.sidebar.routeStatistics.notStarted')}
              onClick={this.toggle}
            />
            <IconButton
              dataTestId="started-button"
              className="filterHeaderFindStarted"
              data-active={this.state.STARTED}
              data-key="STARTED"
              message={getResourceTo('RouteMonitor.sidebar.routeStatistics.started')}
              onClick={this.toggle}
            />
            <IconButton
              dataTestId="departed-origin-button"
              className="filterHeaderFindOnRoute"
              data-active={this.state.DEPARTED_ORIGIN}
              data-key="DEPARTED_ORIGIN"
              message={getResourceTo('RouteMonitor.sidebar.routeStatistics.departedOrigin')}
              onClick={this.toggle}
            />
            <IconButton
              dataTestId="arrived-origin-button"
              className="filterHeaderFindArrived"
              data-active={this.state.ARRIVED_ORIGIN}
              data-key="ARRIVED_ORIGIN"
              message={getResourceTo('RouteMonitor.sidebar.routeStatistics.arrivedOrigin')}
              onClick={this.toggle}
            />
          </div>
          <Flex className="routeSearchGroup">
            <IconButton
              dataTestId="filter-header-tag"
              className="filterHeaderTagIcon"
              data-active={this.state.openedTag}
              data-key="openedTag"
              message={getResourceTo('Toolbar.hint.tags.equipment')}
              onClick={this.toggle}
            />
            <IconButton
              dataTestId="filter-header-date"
              className="filterHeaderFindAll"
              data-active={this.state.openedDates}
              data-key="openedDates"
              message={getResourceTo('Filter.Stop.routeDate.Range')}
              onClick={this.toggle}
            />
            <IconButton
              dataTestId="filter-header-org"
              className="filterHeaderSearchIcon"
              data-active={this.state.openedOrg}
              data-key="openedOrg"
              message={getResourceTo('route.organization')}
              onClick={this.toggle}
            />
            <IconButton
              onClick={toggleViewMode}
              dataTestId={cardViewMode === 'comfortable' ? 'mode-comfortable' : 'mode-compact'}
              message={getResourceTo('RouteMonitor.filter.toggleRouteView')}
            >
              <img
                src={cardViewMode === 'comfortable' ? Comfortable : CompactIcon}
                alt="Toggle Route card view"
              />
            </IconButton>
          </Flex>
        </div>
        <Flex
          shouldShow={shouldRenderClearButton}
          className="filterHeaderFieldsContainer"
          flexDirection="column"
        >
          <MonetDateRange
            ref="dateRange"
            onSelectCallback={this.getRoutesByDates}
            rootClassName="dateRange"
          />
          <MonetOrganization
            ref="organizationField"
            afterSelectRow={this.getRoutes}
          />
          <MonetTag
            ref="tagField"
            afterSelectRow={this.getRoutes}
          />
          {shouldRenderClearButton && (
            <Button
              onClick={this.clearFilters}
              variant="secondary"
              className="btnClearFilter"
            >
              {getResourceTo('RouteMonitor.Btn.ClearFilters')}
            </Button>
          )}
        </Flex>
      </Flex>
    );
  }
}

export default connect(({ filter, tabs }) => ({ filter, tabs }))(Filter);
